import React, { useEffect, useState } from "react";
import { FaBell } from "react-icons/fa";
import {
  getBrowserNotificationPermission,
  isAuthenticated,
  isInstalledAppShell,
  isPushSupported,
  subscribeToPushNotifications,
} from "../../Helper/pwa";
import "./JobAlertsPrompt.css";

const DISMISS_KEY = "cajp-alerts-prompt-dismissed-at";
const DISMISS_MS = 7 * 24 * 60 * 60 * 1000;

const wasDismissedRecently = () => {
  const raw = localStorage.getItem(DISMISS_KEY);
  if (!raw) return false;
  const ts = Number(raw);
  if (!ts) return false;
  return Date.now() - ts < DISMISS_MS;
};

const JobAlertsPrompt = () => {
  const [visible, setVisible] = useState(false);
  const [busy, setBusy] = useState(false);
  const [blocked, setBlocked] = useState(false);

  useEffect(() => {
    const setup = async () => {
      if (!isAuthenticated() || !isPushSupported()) {
        return;
      }

      const permission = getBrowserNotificationPermission();
      if (permission === "granted") {
        await subscribeToPushNotifications();
        return;
      }
      if (permission === "unsupported") return;

      if (permission === "denied") {
        if (isInstalledAppShell() && !localStorage.getItem("cajp-alerts-blocked-seen")) {
          setBlocked(true);
          setVisible(true);
        }
        return;
      }

      if (wasDismissedRecently() && !isInstalledAppShell()) {
        return;
      }

      setVisible(true);
    };

    setup();
  }, []);

  if (!visible) return null;

  const dismiss = (persist = true) => {
    if (persist) localStorage.setItem(DISMISS_KEY, String(Date.now()));
    if (blocked) localStorage.setItem("cajp-alerts-blocked-seen", "1");
    setVisible(false);
  };

  const enable = async () => {
    setBusy(true);
    const result = await subscribeToPushNotifications();
    setBusy(false);
    if (result.success) {
      localStorage.removeItem(DISMISS_KEY);
      setVisible(false);
      return;
    }
    if (result.permission === "denied" || result.reason === "permission_denied") {
      setBlocked(true);
    }
  };

  return (
    <div className="job-alerts-prompt" role="dialog" aria-labelledby="job-alerts-title">
      <div className="job-alerts-prompt__card">
        <span className="job-alerts-prompt__icon" aria-hidden="true">
          <FaBell />
        </span>
        <div className="job-alerts-prompt__copy">
          <h2 id="job-alerts-title">
            {blocked ? "Notifications are blocked" : "Enable notifications"}
          </h2>
          <p>
            {blocked
              ? "On Android: Settings → Apps → CAJobPortal → Notifications, then open the app again."
              : "Receive timely updates on relevant openings, application activity, and hiring decisions."}
          </p>
        </div>
        <div className="job-alerts-prompt__actions">
          <button type="button" className="job-alerts-prompt__later" onClick={() => dismiss(true)}>
            Not now
          </button>
          {!blocked && (
            <button
              type="button"
              className="job-alerts-prompt__enable"
              onClick={enable}
              disabled={busy}
            >
              {busy ? "Please wait…" : "Allow"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default JobAlertsPrompt;
